"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeComponent = void 0;
const components_1 = require("@/store/ducks/components");
const components_2 = require("@/services/components");
function removeComponent(componentId) {
    return async (dispatch) => {
        dispatch((0, components_1.deleteComponent)());
        try {
            await (0, components_2.deleteComponentService)(componentId);
            dispatch((0, components_1.deleteComponentSuccess)());
            return Promise.resolve();
        }
        catch (error) {
            if (error && error?.code === 400) {
                dispatch((0, components_1.deleteComponentError)("This component is already associated to a product."));
            }
            dispatch((0, components_1.deleteComponentError)("Error while deleting the component"));
            return Promise.reject();
        }
    };
}
exports.removeComponent = removeComponent;
